// extracted by mini-css-extract-plugin
module.exports = {"balance":"_8b30f42","icon":"_17ab71f","chest":"_45265fe","tournamentMoney":"_f5c036b"};